import * as z from 'zod';

import { emergencyContactQuerySchema } from './emergency-contact-query-schema';

export const emergencyContactMutationSchema = emergencyContactQuerySchema
  .omit({
    phone_numbers: true,
  })
  .extend({
    phone_numbers: z.array(z.number()),
  });

export type EmergencyContactMutationSchema = z.infer<typeof emergencyContactMutationSchema>;
